var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse, _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _line5, _line6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServerDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 156,
    viewBox: "0 0 228 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.124 43.2333H75.5311V130.02H150.124V43.2333Z",
    fill: "#8792A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.655 34.6264H71C69.3431 34.6264 68 35.9695 68 37.6264V62.4678C68 64.1246 69.3431 65.4678 71 65.4678H154.655C156.312 65.4678 157.655 64.1246 157.655 62.4678V37.6264C157.655 35.9695 156.312 34.6264 154.655 34.6264Z",
    fill: "#DDE4EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.655 71.2057H71C69.3431 71.2057 68 72.5489 68 74.2057V99.0471C68 100.704 69.3431 102.047 71 102.047H154.655C156.312 102.047 157.655 100.704 157.655 99.0471V74.2057C157.655 72.5489 156.312 71.2057 154.655 71.2057Z",
    fill: "#DDE4EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.655 107.785H71C69.3431 107.785 68 109.128 68 110.785V135.626C68 137.283 69.3431 138.626 71 138.626H154.655C156.312 138.626 157.655 137.283 157.655 135.626V110.785C157.655 109.128 156.312 107.785 154.655 107.785Z",
    fill: "#DDE4EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.738 40.0057H131V45.7436H136.738V40.0057Z",
    fill: "#62739E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M144.986 40.0057H139.248V45.7436H144.986V40.0057Z",
    fill: "#C7D0DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.234 40.0057H147.497V45.7436H153.234V40.0057Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.738 76.2264H131V81.9643H136.738V76.2264Z",
    fill: "#62739E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M144.986 76.2264H139.248V81.9643H144.986V76.2264Z",
    fill: "#C7D0DD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.234 76.2264H147.497V81.9643H153.234V76.2264Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.738 112.447H131V118.185H136.738V112.447Z",
    fill: "#62739E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M144.986 112.447H139.248V118.185H144.986V112.447Z",
    fill: "#C7D0DD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.234 112.447H147.497V118.185H153.234V112.447Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113,
    cy: 151.393,
    rx: 80,
    ry: 3.7664,
    fill: "url(#paint0_radial)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2256,
    cy: 52.4164,
    r: 5,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.1206,
    cy: 4.52142,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.899,
    cy: 126.521,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.9375,
    y1: 86.0864,
    x2: 3.9375,
    y2: 92.0864,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 89.3364,
    x2: 1,
    y2: 89.3364,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 209.187,
    y1: 27.8364,
    x2: 209.188,
    y2: 33.8364,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 212.25,
    y1: 31.0864,
    x2: 206.25,
    y2: 31.0864,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 149.953,
    y1: 11.4492,
    x2: 149.953,
    y2: 17.4492,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 153.016,
    y1: 14.6992,
    x2: 147.016,
    y2: 14.6992,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113 151.393) rotate(90) scale(3.7664 80)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6ECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF7",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerDown);
export default __webpack_public_path__ + "static/media/server_down.0311e91ea76f479b83aa4ca705cf895c.svg";
export { ForwardRef as ReactComponent };